import { Component } from '@angular/core'

@Component({
  templateUrl: './student-manual-en.component.html',
  styleUrls: ['../student-manual.component.less'],
  selector: 'app-student-manual-en',
})
export class StudentManualComponentEn {}
